import React, {useContext} from 'react';
import Tabs from './Tabs';
// import Tabs from "./Tab";
import LandingPage from '../../Pages/LandingPage';
import {ThemeContext} from '../../themes/ThemeProvider';

function NBMaintenance() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [mainTabValue, setMainTabValue] = React.useState(0);
  const tabs = ['Batches'];

  const handleChange = (event, newValue) => {
    setMainTabValue(newValue);
  };

  return (
  // <>

    //    <LandingPage>
    //     {/* <div className={`landing-page`} role="main"   **Code may require**** >
    //     <div className="fixed-header-bgcolor"></div>    **Code may require****  */}
    //           title={"Letters"}
    //     allAntTabs={tabs}
    //     showTabs={true}
    //     tabValue={mainTabValue}
    //     handleTabChange={handleChange}
    //   >
    //     <div className="global-field-dash-board">
    //       <div className={classes.cardStyleWhite}>
    //         <div>{mainTabValue === 0 && <Tabs />}</div>
    //       </div>
    //     </div>
    //   </LandingPage>
    //   </LandingPage>
    // </>
    <>
      <LandingPage
        title={'Letter Batches'}
        allAntTabs={tabs}
        showTabs={true}
        tabValue={mainTabValue}
        handleTabChange={handleChange}
      >
        <div className="global-field-dash-board">
          <div className={classes.cardStyleWhite}>
            <div>{mainTabValue === 0 && <Tabs />}</div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default NBMaintenance;
